import { useState } from 'react';
import { Link } from 'react-router';
import { Alert, Button } from '../../components/ui';
import { t } from '../../i18n';
import { api } from '../../lib/api';
import { errorMessage } from '../../lib/errors';

type Kind = 'mfa' | 'clave';

/** Portal de autoservicio de RR. HH. (guía 7.5): reset de MFA o de contraseña, que crean un ticket para IT. */
export function ResetActions({ userId, fullName }: { userId: string; fullName: string }) {
  const [confirming, setConfirming] = useState<Kind | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ticket, setTicket] = useState<{ number: number; code: string } | null>(null);

  async function request(kind: Kind) {
    setBusy(true);
    setError(null);
    try {
      setTicket(await api<{ number: number; code: string }>(`/api/usuarios/${userId}/${kind === 'mfa' ? 'reset-mfa' : 'reset-clave'}`, { method: 'POST' }));
      setConfirming(null);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  if (ticket)
    return (
      <p className="text-sm text-green-800" role="status">
        {t('us.reset_ticket')}{' '}
        <Link to={`/tickets/${ticket.number}`} className="font-medium underline">
          {ticket.code}
        </Link>
      </p>
    );
  if (confirming)
    return (
      <div className="space-y-2 text-sm">
        {error && <Alert>{error}</Alert>}
        <p className="text-slate-700">{t(confirming === 'mfa' ? 'us.reset_mfa_confirmar' : 'us.reset_clave_confirmar', { nombre: fullName })}</p>
        <div className="flex gap-2">
          <Button disabled={busy} onClick={() => void request(confirming)}>
            {t('us.si_pedir')}
          </Button>
          <Button variant="secondary" onClick={() => setConfirming(null)}>
            {t('comun.volver')}
          </Button>
        </div>
      </div>
    );
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1">
      <Button variant="link" className="text-sm" onClick={() => setConfirming('mfa')}>
        {t('us.reset_mfa')}
      </Button>
      <Button variant="link" className="text-sm" onClick={() => setConfirming('clave')}>
        {t('us.reset_clave')}
      </Button>
    </div>
  );
}
